export default __webpack_public_path__ + "static/media/local-list-actions-2.8a61b5c0.png";